import React from 'react'
import './style.css'
class WordsDistinguish extends React.Component {
    render() {
        return(
            <div className='bankcard'>
                <h1>手写文字识别</h1>
            </div>
        )
    }
}
export default WordsDistinguish